import { useEffect, useState } from "react";

export const RangoSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-rango"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="0">Consolidado</option>
      <option value="30">1 a 30 dias</option>
      <option value="60">31 a 60 dias</option>
      <option value="90">61 a 90 dias</option>
      <option value="91">Más de 90 dias</option>
    </select>
  );
};
